module.exports = __webpack_public_path__ + "img/BannerMob-Quanta-Bank-02.3534a3bb.jpg";